// jQuery('.featured-collection--products').slick({
//     infinite: false,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     arrows: false,
//     dots: false, 
//     responsive: [
//         {
//             breakpoint: 1100,
//             settings: {
//                 slidesToShow: 3,
//                 centerMode: false,
//                 slidesToScroll: 1,
//                 infinite: true,
//                 dots: true
//             }
//         },
//         {
//             breakpoint: 768,
//             settings: {
//                 slidesToShow: 2,
//                 centerMode: false,
//                 slidesToScroll: 1,
//                 infinite: true,
//                 dots: true
//             }
//         },
//         {
//             breakpoint: 430,
//             settings: {
//                 slidesToShow: 1,
//                 centerMode: true,
//                 slidesToScroll: 1,
//                 infinite: true,
//                 dots: true
//             }
//         }
//     ]
// });


jQuery('.partners-logo .featured-grid--body--container').slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    responsive: [
        {
            breakpoint: 1000,
            settings: {
                slidesToShow: 4,
                centerMode: false,
                slidesToScroll: 1,
                infinite: false,
                dots: false
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                centerMode: true,
                slidesToScroll: 1,
                infinite: true,
                dots: false
            }
        }
    ]
});

jQuery('.testimonials .featured-grid--body--container').slick({
    slidesToShow: 2.6,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
         
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                centerMode: true,
                slidesToScroll: 1,
                infinite: true,
                
            }
        }
    ]
});


jQuery('.masterclass-products  product-grid-root').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    prevArrow: $('.masterclass-arrow .prev'),
    nextArrow: $('.masterclass-arrow .next'),
    responsive: [ 
         
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2, 
                slidesToScroll: 1,
                infinite: false,
                arrows: false,
                prevArrow: false, 
                nextArrow: false

            }
        }
    ]
});


// slick on mobile only 
 
if (window.innerWidth < 768) {
    mobileOnlySlider();
}
$(window).resize(function (e) {
    if (window.innerWidth < 768) { 
            mobileOnlySlider(); 
    }  
});
function mobileOnlySlider() {
    jQuery('.text-columns.mobile-slider  .featured-grid--body--container').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 5000,
                settings: 'unslick' 
            },
            {
                breakpoint: 768,
                settings: 'unslick'
            },

            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false,
                    prevArrow: false,
                    nextArrow: false,
                    autoplay: true,
                    autoplaySpeed: 200000,

                }
            }
        ]
    });
}



